<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>{{ content }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button type="button" color="accent" [mat-dialog-close]="true">Sim</button>
  <button mat-button type="button" color="warn" mat-dialog-close>Não</button>
</mat-dialog-actions>
